import { render, staticRenderFns } from "./WidgetTravelBookingStats.vue?vue&type=template&id=3fe9b4db"
import script from "./WidgetTravelBookingStats.vue?vue&type=script&lang=js"
export * from "./WidgetTravelBookingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports